var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaMusicLargeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2994",
    "data-name": "Group 2994",
    transform: "translate(-560 -1280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 40,
    height: 40,
    transform: "translate(560 1280)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(570.662 1288.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M14.506,2H6.335A2.335,2.335,0,0,0,4,4.335V23.011a2.335,2.335,0,0,0,2.335,2.335H20.342a2.335,2.335,0,0,0,2.335-2.335V10.171Z",
    transform: "translate(-4 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M13,2v8.171h8.171",
    transform: "translate(-2.494 -2)",
    fill: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "musical-notes",
    d: "M87.177,32.108a.543.543,0,0,0-.475-.094l-4.186,1.125a.678.678,0,0,0-.5.662v4.746a.329.329,0,0,1-.233.311h0l-1.092.378a1.017,1.017,0,0,0-.688.988,1.166,1.166,0,0,0,.488.958,1.15,1.15,0,0,0,.674.22,1.172,1.172,0,0,0,.373-.062l.008,0L82,41.173a1,1,0,0,0,.687-.947V35.773a.323.323,0,0,1,.255-.317h0l3.667-.98a.084.084,0,0,1,.105.081v2.981a.323.323,0,0,1-.233.308l-.005,0-1.069.38a1.031,1.031,0,0,0-.709.989,1.169,1.169,0,0,0,.488.962,1.147,1.147,0,0,0,1.048.154l.008,0,.459-.167a1,1,0,0,0,.687-.947V32.541A.541.541,0,0,0,87.177,32.108Z",
    transform: "translate(496.002 1267.712)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaMusicLargeIcon);
export default __webpack_public_path__ + "static/media/media-music-large-icon.63530af59d0b4f2ad0ecb94f94a3ed1b.svg";
export { ForwardRef as ReactComponent };